type Props = {
  kicker: string;
  title: string;
  desc?: string;
  href: string;
  anchorId: string;
  accent?: 'primary' | 'accent';
};

export default function SectionHead({ kicker, title, desc, href, anchorId, accent = 'primary' }: Props) {
  const dot = accent === 'primary' ? 'bg-primary-500' : 'bg-accent-500';
  return (
    <div id={anchorId} className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between scroll-mt-24">
      <div className="flex items-start gap-3">
        <span className={`mt-1.5 h-8 w-1.5 rounded-full ${dot}`}></span>
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">{kicker}</span>
          <h2 className="mt-1 font-heading text-xl md:text-3xl font-black text-foreground-950">{title}</h2>
          {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-500">{desc}</p>}
        </div>
      </div>
      <a
        href={href}
        className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
      >
        查看全部 <i className="ri-arrow-right-line"></i>
      </a>
    </div>
  );
}